import { pb } from "lib/pocketbase";

async function getTalents() {
  try {
    let response = await pb.collection("talent").getFullList({
      sort: "sort_order",
      expand: "category",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

export { getTalents };
